import React from "react";

const CSS = `
@keyframes tgwUp{from{opacity:0;transform:translateY(16px) scale(.985)}to{opacity:1;transform:none}}
@keyframes tgInfoIn{from{opacity:0;transform:translateY(6px) scale(.98)}to{opacity:1;transform:none}}
@keyframes tgwDraw{to{stroke-dashoffset:0}}
@keyframes tgwPing{0%{box-shadow:0 0 0 0 rgba(66,115,209,.45)}70%{box-shadow:0 0 0 10px rgba(66,115,209,0)}100%{box-shadow:0 0 0 0 rgba(66,115,209,0)}}
@keyframes tgwWash{0%{transform:scale(1)}50%{transform:scale(1.06) translate(-2%,2%)}100%{transform:scale(1)}}
@keyframes tgwPop{from{opacity:0;transform:scale(.86)}to{opacity:1;transform:none}}
@keyframes tgwGrowY{from{transform:scaleY(0)}to{transform:scaleY(1)}}
@keyframes tgwGrowX{from{transform:scaleX(0)}to{transform:scaleX(1)}}
@keyframes tgwPetal{from{opacity:0;transform:scale(.2)}to{opacity:1;transform:scale(1)}}
@keyframes tgwShine{from{transform:translateX(-140%) skewX(-16deg)}to{transform:translateX(380%) skewX(-16deg)}}
@keyframes tgwBounceY{0%{transform:scaleY(0)}72%{transform:scaleY(1.08)}100%{transform:scaleY(1)}}
@keyframes tgwFloat{0%,100%{transform:translateY(0)}50%{transform:translateY(-6px)}}
@keyframes tgwPeak{0%,100%{filter:drop-shadow(0 0 0 transparent)}50%{filter:drop-shadow(0 0 10px rgba(66,115,209,.55))}}
@keyframes tgwGlow{0%,100%{filter:drop-shadow(0 0 2px rgba(66,115,209,.15))}50%{filter:drop-shadow(0 0 10px rgba(66,115,209,.45))}}
@keyframes tgwSweep{from{transform:rotate(-90deg);opacity:1}70%{opacity:1}to{transform:rotate(270deg);opacity:0}}
@keyframes tgwLegend{from{opacity:0;transform:translateX(12px)}to{opacity:1;transform:none}}
@keyframes tgwSpin{from{transform:rotate(-25deg) scale(.88);opacity:0}to{transform:rotate(0) scale(1);opacity:1}}
.tgw-a{animation:tgwUp .7s cubic-bezier(.16,1,.3,1) both}
.tgw-a1{animation-delay:.04s}.tgw-a2{animation-delay:.1s}.tgw-a3{animation-delay:.18s}.tgw-a4{animation-delay:.26s}
.tgw-live{width:8px;height:8px;border-radius:99px;background:#4273D1;animation:tgwPing 1.8s ease-out infinite;flex:none}
.tg-info-dot:hover{transform:scale(1.1);opacity:1}
.tg-info-dot{opacity:.75}
.tgw-growY{transform-box:fill-box;transform-origin:center bottom;animation:tgwBounceY .8s cubic-bezier(.16,1,.3,1) both}
.tgw-growX{transform-origin:left center;animation:tgwGrowX .8s cubic-bezier(.16,1,.3,1) both}
.tgw-pop{animation:tgwPop .45s cubic-bezier(.16,1,.3,1) both}
.tgw-petal{transform-origin:180px 168px;animation:tgwPetal .55s cubic-bezier(.16,1,.3,1) both;cursor:pointer;transition:opacity .15s,filter .15s}
.tgw-petal.is-peak{animation:tgwPetal .55s cubic-bezier(.16,1,.3,1) both, tgwPeak 2.4s 1s ease-in-out infinite}
.tgw-clock:hover .tgw-petal{opacity:.5}
.tgw-clock .tgw-petal:hover{opacity:1;filter:brightness(1.1);transform:scale(1.07)!important}
.tgw-hand{transform-origin:180px 168px;animation:tgwSweep 1.5s .2s cubic-bezier(.16,1,.3,1) both}
.tgw-draw{animation:tgwDraw 1.05s cubic-bezier(.16,1,.3,1) both}
.tgw-gact{animation:tgwDraw 1.1s cubic-bezier(.16,1,.3,1) both, tgwGlow 2.8s 1.1s ease-in-out infinite}
.tgw-ring{animation:tgwDraw 1.15s cubic-bezier(.16,1,.3,1) both}
.tgw-rings{overflow:visible}
.tgw-rings-spin{animation:tgwPop .55s cubic-bezier(.16,1,.3,1) both}
.tgw-rings g{transition:opacity .18s}
.tgw-rings:hover g{opacity:.4}
.tgw-rings g:hover{opacity:1}
.tgw-rings g:hover .tgw-ring{filter:brightness(1.12)}
.tgw-leg{animation:tgwLegend .4s cubic-bezier(.16,1,.3,1) both}
.tgw-bub g{animation:tgwPop .55s cubic-bezier(.16,1,.3,1) both}
.tgw-bub g:nth-child(1){animation:tgwPop .55s cubic-bezier(.16,1,.3,1) both, tgwFloat 3.8s 1s ease-in-out infinite}
.tgw-bub g:nth-child(2){animation:tgwPop .55s .08s cubic-bezier(.16,1,.3,1) both, tgwFloat 4.2s 1.2s ease-in-out infinite}
.tgw-bub g:nth-child(3){animation:tgwPop .55s .16s cubic-bezier(.16,1,.3,1) both, tgwFloat 3.5s 1.4s ease-in-out infinite}
@keyframes tgwFlow{to{stroke-dashoffset:0}}
@keyframes tgwChipL{from{opacity:0;transform:translateX(-14px)}to{opacity:1;transform:none}}
@keyframes tgwChipR{from{opacity:0;transform:translateX(14px)}to{opacity:1;transform:none}}
.tgw-flow{stroke-dasharray:1;stroke-dashoffset:1;animation:tgwFlow .95s cubic-bezier(.16,1,.3,1) both;transition:opacity .2s,stroke-width .2s}
.tgw-chip-l{animation:tgwChipL .45s cubic-bezier(.16,1,.3,1) both}
.tgw-chip-r{animation:tgwChipR .45s cubic-bezier(.16,1,.3,1) both}
.tgw-sankey .is-dim{opacity:.28;transition:opacity .2s}
.tgw-flowdot{filter:drop-shadow(0 0 4px rgba(66,115,209,.45))}
.tgw-spot{position:relative}
.tgw-spot::after{content:"";position:absolute;inset:0;border-radius:inherit;pointer-events:none;opacity:0;
  transition:opacity .25s ease;
  background:radial-gradient(230px circle at var(--mx,50%) var(--my,50%),rgba(255,255,255,.35),transparent 72%)}
.tgw-spot:hover::after{opacity:1}
:root[data-theme="dark"] .tgw-spot::after,.dark .tgw-spot::after{
  background:radial-gradient(230px circle at var(--mx,50%) var(--my,50%),rgba(255,255,255,.05),transparent 72%)}
.tgw-zoomseg{transition:left .55s cubic-bezier(.22,.85,.28,1),width .55s cubic-bezier(.22,.85,.28,1),opacity .45s ease,box-shadow .2s ease}
.tgw-zoomwin{transition:left .55s cubic-bezier(.22,.85,.28,1),width .55s cubic-bezier(.22,.85,.28,1)}
.tgw-stage{position:relative;overflow:visible}
.tgw-card{transition:transform .22s cubic-bezier(.16,1,.3,1),box-shadow .22s}
.tgw-card:hover{transform:translateY(-4px)}
@keyframes tgwShimmer{0%{background-position:180% 0}100%{background-position:-80% 0}}
.tgw-shimmer{background:linear-gradient(90deg,var(--tgw-sh0) 0%,var(--tgw-sh1) 46%,var(--tgw-sh0) 100%);
  background-size:200% 100%;animation:tgwShimmer 1.35s ease-in-out infinite;border-radius:8px}
.tgw-row{transition:transform .18s,background .18s,opacity .18s;border-radius:10px}
.tgw-race:hover .tgw-row{opacity:.45}
.tgw-race .tgw-row:hover{opacity:1;transform:translateX(8px);background:rgba(66,115,209,.06)}
.tgw-list .tgw-row:hover{transform:translateX(8px);background:rgba(66,115,209,.06)}
.tgw-tl .tgw-row:hover{transform:none;background:transparent}
.tgw-tl-card{transition:transform .18s,border-color .18s,box-shadow .18s}
.tgw-tl .tgw-row:hover .tgw-tl-card{transform:translateX(6px)}
.tgw-alerts-scroll{overflow-x:hidden;overflow-y:auto;min-height:0;overscroll-behavior:contain;scrollbar-gutter:stable;padding-right:2px}
.tgw-alerts-scroll::-webkit-scrollbar{width:6px}
.tgw-alerts-scroll::-webkit-scrollbar-track{background:transparent}
.tgw-alerts-scroll::-webkit-scrollbar-thumb{background:color-mix(in srgb, currentColor 22%, transparent);border-radius:99px}
.tgw-alert-card{flex-shrink:0;min-width:0;max-width:100%;overflow:hidden;box-sizing:border-box}
.tgw-news-grid{display:grid;grid-template-columns:1fr 1fr;gap:8px}
.tgw-alert-split{flex:1;min-height:0;display:grid;grid-template-columns:minmax(220px,300px) minmax(0,1fr)}
.tgw-tools-c{display:grid;grid-template-columns:minmax(0,1.05fr) minmax(0,1fr);gap:10px;align-items:stretch;width:100%;min-width:0;min-height:0}
.tgw-tools-c.is-fill{flex:1;height:100%;align-self:stretch}
.tgw-tools-rings{min-width:0;min-height:0;display:grid}
.tgw-tools-rings .tgw-rings{width:100%;height:100%;max-width:none;display:block}
.tgw-tools-stack{display:grid;grid-template-rows:repeat(var(--n,6),minmax(44px,1fr));gap:6px;min-height:0}
.tgw-tools-c.is-fill .tgw-tools-stack{height:100%;grid-template-rows:repeat(var(--n,6),minmax(0,1fr))}
.tgw-tool-chip{display:flex;align-items:center;gap:10px;width:100%;min-width:0;min-height:0;padding:8px 12px 8px 8px;border-radius:14px}
.tgw-dots i{transition:transform .18s;cursor:pointer}
.tgw-dots:hover i{opacity:.35}
.tgw-dots i:hover{opacity:1;transform:scale(1.45)!important}
.tgw-bub:hover g{opacity:.4}
.tgw-bub g{cursor:pointer;transform-box:fill-box;transform-origin:center;transition:transform .2s,opacity .18s}
.tgw-bub g:hover{opacity:1;transform:scale(1.1)}
.tgw-sankey path{cursor:pointer}
@media (max-width:980px){
  .tgw-pair,.tgw-pair2{grid-template-columns:1fr!important;height:auto!important;max-height:none!important}
  .tgw-stage{grid-template-columns:1fr!important}
}
@media (max-width:640px){
  .tgw-people-2{grid-template-columns:1fr!important}
  .tgw-tools-c{grid-template-columns:1fr!important}
  .tgw-tools-rings{height:200px}
  .tgw-alert-split{grid-template-columns:1fr!important}
  .tgw-news-grid{grid-template-columns:1fr!important}
}
@media (prefers-reduced-motion:reduce){
  .tgw-a,.tgw-live,.tg-info-dot,.tgw-growY,.tgw-growX,.tgw-pop,.tgw-petal,.tgw-petal.is-peak,.tgw-draw,.tgw-gact,.tgw-ring,.tgw-rings,.tgw-rings-spin,.tgw-leg,.tgw-hand,.tgw-stage::after,.tgw-bub g,.tgw-sankey path,.tgw-flow,.tgw-chip-l,.tgw-chip-r,.tgw-shimmer{animation:none!important}
  .tg-info-pop{animation:none!important}
  .tgw-card,.tgw-row{transition:none}
  .tgw-spot::after{display:none}
  .tgw-zoomseg{transition:opacity .2s ease}
  .tgw-zoomwin{transition:none}
}
`;

export function WowMotion() {
  return <style>{CSS}</style>;
}

export function useSpot() {
  return React.useCallback((e) => {
    const el = e.currentTarget;
    const r = el.getBoundingClientRect();
    el.style.setProperty("--mx", `${((e.clientX - r.left) / r.width) * 100}%`);
    el.style.setProperty("--my", `${((e.clientY - r.top) / r.height) * 100}%`);
  }, []);
}

export function useCount(n, ready) {
  const [v, setV] = React.useState(ready ? 0 : n);
  React.useEffect(() => {
    if (!ready) { setV(0); return undefined; }
    const reduce = typeof window !== "undefined"
      && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) { setV(n); return undefined; }
    const t0 = performance.now();
    let raf;
    const tick = (now) => {
      const p = Math.min(1, (now - t0) / 900);
      setV(Math.round(n * (1 - (1 - p) ** 3)));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [n, ready]);
  return v;
}

export default WowMotion;
